import {
  CarrierSchema,
  ServiceSchema,
} from "@redotech/redo-model/fulfillments/fulfillment-carriers-and-services";
import * as z from "zod";

const weightInputSchema = z.object({ lbs: z.number() });

const rateCalculatorInputSchema = z.object({
  mode: z.literal("simple"),
  originZip: z.string(),
  originCountry: z.string(),
  destinationZip: z.string(),
  destinationCountry: z.string(),
  weight: weightInputSchema,
});

const rateCalculatorRateSchema = z.object({
  carrier: CarrierSchema,
  service: ServiceSchema,
  rate: z.string(),
  currency: z.string(),
  delivery_days: z.number().nullish(),
  delivery_date: z.string().nullish(),
  delivery_date_guaranteed: z.boolean().nullish(),
  provider: z.string(),
  is_merchant_carrier_account: z.boolean().nullish(),
});

export interface RateCalculatorRate
  extends z.infer<typeof rateCalculatorRateSchema> {}

const messageSchema = z.object({
  carrier: z.string().optional(),
  message: z.string().optional(),
});

export const getRateCalculatorRates = {
  name: "getRateCalculatorRates" as const,
  input: rateCalculatorInputSchema,
  output: z.object({
    rates: z.array(rateCalculatorRateSchema),
    messages: z.array(messageSchema),
  }),
};
